import LANGUAGES from './languages.json';

export default LANGUAGES;
